/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCompletionsQueryVariables = Types.Exact<{
  appSessionId: Types.Scalars["AppSessionId"]["input"];
  source: Types.Scalars["String"]["input"];
  position: Types.Scalars["Int"]["input"];
}>;

export type GetCompletionsQuery = {
  readonly __typename: "Query";
  readonly getCompletions: {
    readonly __typename: "CompletionOptions";
    readonly cursorStart: number | null;
    readonly cursorEnd: number | null;
    readonly matches: ReadonlyArray<{
      readonly __typename: "CompletionMatch";
      readonly name: string;
      readonly type: string;
    }>;
  };
};

export const GetCompletionsDocument = /*#__PURE__*/ gql`
  query GetCompletions(
    $appSessionId: AppSessionId!
    $source: String!
    $position: Int!
  ) {
    getCompletions(
      appSessionId: $appSessionId
      source: $source
      position: $position
    ) {
      matches {
        name
        type
      }
      cursorStart
      cursorEnd
    }
  }
`;

/**
 * __useGetCompletionsQuery__
 *
 * To run a query within a React component, call `useGetCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionsQuery({
 *   variables: {
 *      appSessionId: // value for 'appSessionId'
 *      source: // value for 'source'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useGetCompletionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCompletionsQuery,
    GetCompletionsQueryVariables
  > &
    (
      | { variables: GetCompletionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompletionsQuery, GetCompletionsQueryVariables>(
    GetCompletionsDocument,
    options,
  );
}
export function useGetCompletionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompletionsQuery,
    GetCompletionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCompletionsQuery, GetCompletionsQueryVariables>(
    GetCompletionsDocument,
    options,
  );
}
export function useGetCompletionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCompletionsQuery,
    GetCompletionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCompletionsQuery,
    GetCompletionsQueryVariables
  >(GetCompletionsDocument, options);
}
export type GetCompletionsQueryHookResult = ReturnType<
  typeof useGetCompletionsQuery
>;
export type GetCompletionsLazyQueryHookResult = ReturnType<
  typeof useGetCompletionsLazyQuery
>;
export type GetCompletionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCompletionsSuspenseQuery
>;
export type GetCompletionsQueryResult = Apollo.QueryResult<
  GetCompletionsQuery,
  GetCompletionsQueryVariables
>;
